class NavigationVertical {
	constructor() {
		if (document.querySelector('.navigation-vertical')) {
			this.navigationVertical();
		}
	}

	navigationVertical() {
		const activeLink = document.querySelector('.navigation-vertical a.menu-link.active');

		if (activeLink) {
			if (activeLink.classList.contains('has-submenu')) {
				activeLink.classList.add('open');
				activeLink.nextElementSibling.classList.add('open'); // submenu
			}

			const parentItem1 = activeLink.parentElement.parentElement;
			const parentItem2 = activeLink.parentElement.parentElement.parentElement.parentElement;
			const parentItem3 = activeLink.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
			const parentItem4 = activeLink.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
			const parentItem5 = activeLink.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;

			setItems(parentItem1);
			setItems(parentItem2);
			setItems(parentItem3);
			setItems(parentItem4);
			setItems(parentItem5);

			function setItems(item) {
				if (item && item.classList.contains('submenu')) {
					item.classList.add('open');
					item.previousElementSibling.classList.add('open');
				}
			}
		}
	}
}

new NavigationVertical();
